// @ts-nocheck

class ProductInformation extends HTMLElement {
  constructor() {
    super();

    this.isStickySidebar = this.dataset.stickySidebar;
    this.sticky = null;

    if (this.isStickySidebar === "true") {
      this.moveDrawers();
      this.init();
      this.observeMediaHeight();
      this.observeSidebarChanges(); // 🔥 NEW
    }
  }

  init() {
    const sidebar = this.querySelector('.product-information-inner');
    if (!sidebar || !window.StickySidebar) return;

    const header = document.querySelector('custom-header');
    const topSpacing = header ? header.offsetHeight : 0;

    if (this.sticky) {
      this.sticky.destroy?.();
      this.sticky = null;
    }

    this.sticky = new window.StickySidebar(this, {
      containerSelector: '.product-main',
      innerWrapperSelector: '.product-information-inner',
      topSpacing,
      bottomSpacing: 0
    });
  }

  // detect injected content (recommendations, lazy load, etc.)
  observeSidebarChanges() {
    const target = this.querySelector('.product-information-inner');
    if (!target) return;

    this.mutationObserver = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.addedNodes.length > 0) {
          clearTimeout(this._reinitTimer);

          this._reinitTimer = setTimeout(() => {
            this.init();
          }, 100);
          break;
        }
      }
    });

    this.mutationObserver.observe(target, {
      childList: true,
      subtree: true
    });
  }

  observeMediaHeight() {
    const buttons = document.querySelectorAll('.load-more-images-wrapper button');
    if (!buttons.length) return;

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        this.init();
      });
    });
  }

  moveDrawers() {
    const drawers = this.querySelectorAll('custom-drawer');
    if (!drawers.length) return;

    const parent = this.parentElement;

    drawers.forEach(drawer => {
      parent.appendChild(drawer);
    });
  }
}

if (!customElements.get('product-information')) {
  customElements.define('product-information', ProductInformation);
}